import { filterDuplicates } from '@nu-art/ts-common';
export const LogicType_Or = '||';
export const LogicType_Equals = '===';
export const LogicType_NotEquals = '!==';
export const LogicType_And = '&&';
export const LogicType_Self = 'self';
export const LogicType_InRange = 'in-range';
export const LogicType_AboveRange = '> range';
export const LogicType_BelowRange = '< range';
export const LogicType_InNormal = 'in-normal-range';
export const LogicType_AboveNormal = '> normal-range';
export const LogicType_BelowNormal = '< normal-range';
export const LogicType_Complex = '?';
export const LogicType_InSet = 'in-set';
export const LogicType_NotInSet = 'not-in-set';
export const LogicType_Exists = 'exists';
export const LogicType_NotExists = 'not-exists';
export const LogicType_LessThan = '<';
export const LogicType_LessOrEquals = '<=';
export const LogicType_GreaterThan = '>';
export const LogicType_GreaterOrEqual = '>=';
export const LogicType_In = 'In';
export const LogicType_Add = '+';
export const LogicType_IsFalse = 'is-false';
export const LogicType_IsTrue = 'is-true';
export const LogicType_Delta = 'Δ';
export const LogicType_DeltaPercentage = 'Δ%';
export const LogicType_DeltaGreaterEquals = 'Δ>=';
export const LogicType_DeltaGreaterThan = 'Δ>';
export const LogicType_DeltaLesserEquals = 'Δ<=';
export const LogicType_DeltaLesserThan = 'Δ<';
export const LogicType_DeltaEquals = 'Δ===';
export const LogicType_DeltaIn = 'ΔIn';
export const LogicType_DeltaPercentageGreaterEquals = 'Δ%>=';
export const LogicType_DeltaPercentageGreaterThan = 'Δ%>';
export const LogicType_DeltaPercentageLesserEquals = 'Δ%<=';
export const LogicType_DeltaPercentageLesserThan = 'Δ%<';
export const LogicType_DeltaPercentageEquals = 'Δ%===';
export const LogicType_DeltaPercentageIn = 'Δ%In';
export const LogicType_StructuredFreeText = '>_';
export const LogicType_IsChiefComplaint = 'is-chief-complaint';
export const allLogicTypes = [
    LogicType_Equals,
    LogicType_LessThan,
    LogicType_LessOrEquals,
    LogicType_GreaterThan,
    LogicType_In,
    LogicType_InSet,
    LogicType_NotEquals,
    LogicType_GreaterOrEqual,
    LogicType_Self,
    LogicType_InRange,
    LogicType_AboveRange,
    LogicType_BelowRange,
    LogicType_InNormal,
    LogicType_AboveNormal,
    LogicType_BelowNormal,
    LogicType_Exists,
    LogicType_NotExists,
    LogicType_IsFalse,
    LogicType_IsTrue,
    LogicType_Delta,
    LogicType_DeltaPercentage,
    LogicType_DeltaGreaterEquals,
    LogicType_DeltaLesserEquals,
    LogicType_DeltaEquals,
    LogicType_DeltaPercentageGreaterEquals,
    LogicType_DeltaPercentageLesserEquals,
    LogicType_DeltaPercentageEquals,
    LogicType_DeltaPercentageGreaterThan,
    LogicType_DeltaPercentageLesserThan,
    LogicType_DeltaGreaterThan,
    LogicType_DeltaLesserThan,
    LogicType_DeltaIn,
    LogicType_NotInSet,
    LogicType_DeltaPercentageIn,
    LogicType_IsChiefComplaint,
];
export const NormalRangeOperators = [LogicType_InNormal, LogicType_AboveNormal, LogicType_BelowNormal];
export const RangeOperators = [LogicType_InRange, LogicType_AboveRange, LogicType_BelowRange];
export const BaseDeltaLogic = [LogicType_DeltaPercentage, LogicType_Delta];
export const AllDeltaLogic = [...BaseDeltaLogic,
    LogicType_DeltaGreaterEquals,
    LogicType_DeltaLesserEquals,
    LogicType_DeltaEquals,
    LogicType_DeltaPercentageGreaterEquals,
    LogicType_DeltaPercentageLesserEquals,
    LogicType_DeltaPercentageEquals,
    LogicType_DeltaPercentageGreaterThan,
    LogicType_DeltaPercentageLesserThan,
    LogicType_DeltaGreaterThan,
    LogicType_DeltaLesserThan,
    LogicType_DeltaIn,
    LogicType_DeltaPercentageIn
];
export const EmptyRightHandOperators = [...NormalRangeOperators, ...BaseDeltaLogic, ...RangeOperators, LogicType_IsFalse, LogicType_IsTrue, LogicType_Self, LogicType_Exists, LogicType_NotExists, LogicType_IsChiefComplaint];
export const NumericVarLogic = [LogicType_LessOrEquals, LogicType_GreaterThan, LogicType_GreaterOrEqual, LogicType_Equals, LogicType_LessThan, LogicType_In, LogicType_Exists, LogicType_NotExists, LogicType_IsChiefComplaint, LogicType_Self, ...BaseDeltaLogic];
export const NormalRangeVarLogic = [...NumericVarLogic, ...BaseDeltaLogic, ...NormalRangeOperators];
export const RangeVarLogic = RangeOperators;
export const EnumeratedVarLogic = [LogicType_Equals, LogicType_NotEquals, LogicType_NotInSet, LogicType_InSet, LogicType_Exists, LogicType_NotExists, LogicType_IsChiefComplaint, LogicType_Self];
export const TupleVarLogic = [LogicType_Equals, LogicType_Exists, LogicType_NotExists, LogicType_IsChiefComplaint, LogicType_Self];
export const Logic_BooleanOperators = [LogicType_IsTrue, LogicType_IsFalse];
export const AllLogics = filterDuplicates([...Logic_BooleanOperators, ...RangeOperators, ...NumericVarLogic, ...NormalRangeVarLogic, ...EnumeratedVarLogic, ...TupleVarLogic]);
export const DeltaTypes = [LogicType_Self, LogicType_In, LogicType_LessThan, LogicType_GreaterThan, LogicType_GreaterOrEqual, LogicType_LessOrEquals, LogicType_Equals];
export const LogicTypes_ToFiler = [
    LogicType_LessThan,
    LogicType_LessOrEquals,
    LogicType_GreaterThan,
    LogicType_GreaterOrEqual,
    ...RangeOperators,
];
// py-JSON conversion consts
export const inSetOperators = [LogicType_Equals, LogicType_InSet, LogicType_NotInSet];
export const inRangeOperators = [LogicType_In, LogicType_Equals, LogicType_GreaterThan, LogicType_GreaterOrEqual, LogicType_LessThan, LogicType_LessOrEquals, LogicType_DeltaGreaterEquals, LogicType_DeltaLesserEquals, LogicType_DeltaPercentageGreaterEquals, LogicType_DeltaPercentageLesserEquals, LogicType_DeltaIn, LogicType_DeltaPercentageIn, LogicType_DeltaEquals, LogicType_DeltaPercentageEquals, LogicType_DeltaLesserThan, LogicType_DeltaGreaterThan, LogicType_DeltaPercentageGreaterThan, LogicType_DeltaPercentageLesserThan];
export const inNormalRangeOperators = [LogicType_InNormal, LogicType_AboveNormal, LogicType_BelowNormal];
//# sourceMappingURL=consts.js.map